module.exports = __webpack_public_path__ + "coin_BLU.png?da18ad3a43f642b2de4ab6e74d68364c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_BLU.png
// module id = 1103
// module chunks = 2